import { Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import assets from "../assets/assets";

const Footer = () => {
  const handleLinkClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer className="bg-gradient-to-r from-[#305669] to-[#1785A] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="mb-4">
              <img
                src={assets.logo01}
                alt="Rice Bazaar Logo"
                className="h-auto w-32"
              />
            </div>
            <p className="text-[#B7E5CD] mb-4">
              Premium quality rice delivered fresh to your doorstep. We are
              committed to bringing you the finest varieties of rice from across
              India.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <div className="space-y-3">
              <Link
                to="/shop"
                onClick={handleLinkClick}
                className="block text-sm text-[#B7E5CD] hover:text-white transition-colors duration-200"
              >
                Shop Rice
              </Link>
              <Link
                to="/contact"
                onClick={handleLinkClick}
                className="block text-sm text-[#B7E5CD] hover:text-white transition-colors duration-200"
              >
                Contact Us
              </Link>
              <Link
                to="/terms"
                onClick={handleLinkClick}
                className="block text-sm text-[#B7E5CD] hover:text-white transition-colors duration-200"
              >
                Terms of Service
              </Link>
              <Link
                to="/privacy"
                onClick={handleLinkClick}
                className="block text-sm text-[#B7E5CD] hover:text-white transition-colors duration-200"
              >
                Privacy Policy
              </Link>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <Mail className="h-4 w-4 text-[#B7E5CD]" />
                <span className="text-sm text-[#B7E5CD]">
                  info@grainly.in.net
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-[#8ABEB9] mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-[#B7E5CD] text-sm">
              © 2025 Grainly. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <Link
                to="/terms"
                onClick={handleLinkClick}
                className="text-sm text-[#B7E5CD] hover:text-white transition-colors duration-200"
              >
                Terms of Service
              </Link>
              <Link
                to="/privacy"
                onClick={handleLinkClick}
                className="text-sm text-[#B7E5CD] hover:text-white transition-colors duration-200"
              >
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
